/* ============================================================================
 * Project        : Deloitte Digital Compliance
 * File           : smartMatchingReducer.js
 * Version        : 1.0.0
 * Author         : Team Neubinary
 * Created On     : 2026-06-24
 *
 * Description    : Digital Compliance for Automation and Governance
 *
 * Change History :
 * ----------------------------------------------------------------------------
 * Date         | Version | Author           | Description
 * ----------------------------------------------------------------------------
 * 2026-06-24   | 1.0.0   | Team Neubinary   | Initial creation
 * <YYYY-MM-DD> | x.x.x   | <Name/Team>      | <Change description>
 * ============================================================================
 *
 * Copyright (c) 2026 AU79 Consulting Services Pvt. Ltd.
 * All Rights Reserved.
 *
 * This source code and its contents are confidential and proprietary to
 * AU79 Consulting Services Pvt. Ltd. Unauthorized copying, reproduction,
 * modification, distribution, or disclosure of this material, in whole or
 * in part, is strictly prohibited without prior written permission from
 * AU79 Consulting Services Pvt. Ltd.
 * ============================================================================
 */
import actionType from "../../actionTypes";

const initialState = {
  suggestions: [],
  status: "loading",
  error: null,
};

export default function smartMatchReducer(state = initialState, action) {
  switch (action.type) {
    case actionType.GET_SMART_MATCH_SUGGESTIONS:
      return {
        ...state,
        suggestions: action.payload?.recommendations || [],
        status: "success",
      };
    case actionType.CLEAR_SMART_MATCH_SUGGESTIONS:
      return {
        ...initialState,
      };
    case actionType.SUBMIT_SMART_MATCH_FEEDBACK:
      // Fire-and-forget: no mutation to suggestions
      return {
        ...state,
        lastFeedbackStatus: action.error ? "error" : "success",
      };

    default:
      return state;
  }
}
